import Vue from 'vue';
import App from './App.vue';
import router from './router';
import Vuex from 'vuex';
import store from './store'
import VantGreen from 'vant-green';
import 'vant-green/lib/index.css';
import '@vant/touch-emulator';
import { NoticeBar, Divider,Tag,Step,Steps,Button,Form,
    Field,Radio,RadioGroup,Checkbox,NumberKeyboard,Icon, 
    Col, Row ,NavBar,Tab, Tabs,Calendar,Search,ContactCard,
    List,Dialog,Overlay,Image as vanImage,Popover} from 'vant';
import 'amfe-flexible'
// import vueTouch from 'vue-touch';

Vue.config.productionTip = false;
// Vue.use(vueTouch,{name:'v-touch'})
Vue.use(VantGreen);
Vue.use(NoticeBar)
Vue.use(Divider)
Vue.use(Tag)
Vue.use(Step);
Vue.use(Steps);
Vue.use(Button);
Vue.use(Form);
Vue.use(Field);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Checkbox);
Vue.use(NumberKeyboard);
Vue.use(Icon)
Vue.use(Row)
Vue.use(Col)
Vue.use(NavBar )
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Calendar)
Vue.use(Search)
Vue.use(ContactCard)
Vue.use(List)
Vue.use(Dialog)
Vue.use(Overlay )
Vue.use(vanImage)
Vue.use(Popover)


// new Vue({
//     router,
//     render: h => h(App),
// }).$mount('#app');

window.vm = new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');